import { apiRequest, ReturnTypeWithPagination, timeAsSeconds } from "@alba-cars/common-modules";

export type LocationPreset = {
  id: string;
  label: string;
  slug: string;
  previousSlugs?: string[] | null;
  googleMapsUrl?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  coordinatesSource?: string | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type LocationPresetOption = LocationPreset & { label: string; value: string };

const LOCATION_PRESETS_ENDPOINT = "/location-presets";

export const getLocationPresets = async (): Promise<LocationPreset[]> => {
  const response = await apiRequest<ReturnTypeWithPagination<LocationPreset[]>>(LOCATION_PRESETS_ENDPOINT, {
    next: {
      revalidate: timeAsSeconds({ hours: 1 }),
      tags: ["location-presets"],
    },
  });

  const data = response.data as unknown;
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === "object" && "result" in data && Array.isArray(data.result)) {
    return data.result as LocationPreset[];
  }

  return [];
};

export const getLocationPresetOptions = async (): Promise<LocationPresetOption[]> => {
  const presets = await getLocationPresets();

  return presets
    .filter((preset) => preset.isActive)
    .map((preset) => ({
      ...preset,
      label: preset.label,
      value: preset.slug,
    }));
};
